import { useQuery } from '@tanstack/react-query'

import { getHeaderData } from 'src/components/navigation/header/headerHelpers'
import { fetchHeaderData } from 'src/lib/react-query/api'

export const queryKeys = {
  menu: ['menu'] as const,
  page: (path: string) => ['page', path] as const
}

export const getHeaderDataQuery = () =>
  fetchHeaderData().then(d => (!d.isError && d.data ? getHeaderData(d.data) : null))

export function useHeaderData() {
  return useQuery({
    queryKey: queryKeys.menu,
    queryFn: getHeaderDataQuery,
    staleTime: 60 * 60 * 1000 // 1 hour
  })
}
